import React from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import StripeCheckout from "../../Components/StripeCheckout";

//publishable Stripe key
// const stripePromise = loadStripe(
//   "pk_live_84hnUuwsD6dLxytzxzRHN0nB"
// );
const stripePromise = loadStripe("pk_test_51PGPslP38WoOV3vpVv33IuVVQdvS9AJ8Nbls98sUd0O7ftoCX1tV7V7AahbcXLZ9pnDDYTwHndUONWdtzlYftoiq00Yp67uXTD");

const Confirmation = () => {
  const product = {
    product_name: "prod 1",
    product_price: "100",
    product_stripe_id: "prod_PDuCs5sKmZ0jHp",
    product_type: "single-product",
  };

  return (
    <Elements stripe={stripePromise}>
      <StripeCheckout product={product} />
    </Elements>
  );
};

export default Confirmation;
